module.exports = __webpack_public_path__ + "static/xiao-selected-78be8d66dfd36b8c1951b10266ea6724.png";